import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import {
  builderIOInit,
  posthogInit,
  posthogStartSessionRecording,
} from "../shared/utils/analytics";

import { ApolloClient, ApolloProvider } from "@apollo/client";
import { ApolloLink, HttpLink, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { ApolloCache, InMemoryCache } from "@apollo/client/cache";

const httpLink = createHttpLink({
  uri: "/me/gql/graphql",
  credentials: "same-origin", // send up cookies for authentication
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

import "./styles/material-overrides.css";

import indexRoutes from "./routes/index.js";

builderIOInit();

posthogInit();
posthogStartSessionRecording();

const hist = createBrowserHistory();

ReactDOM.render(
  <ApolloProvider client={client}>
    <Router history={hist}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return (
            <Route path={prop.path} component={prop.component} key={key} />
          );
        })}
      </Switch>
    </Router>
  </ApolloProvider>,
  document.getElementById("portal_container")
);
